import { GutachtenBefangenheitDisplayModel, GutachtenListDisplayModel, GutachtenListDisplayModelFormGroup } from '@/api/model-index';
import { ConfirmationDialogAction, ConfirmationDialogResult } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Validators } from '@angular/forms';
import { Constants } from '@/constants';
import { FocusManagedDialogComponent } from '@/core/components/dialogs/focus-managed-dialog.component';
import { FocusService } from '@/core/services/focus.service';

@Component({
  selector: 'app-befangenheitsdialog',
  templateUrl: './befangenheitsdialog.component.html',
  styleUrls: ['./befangenheitsdialog.component.scss']
})
export class BefangenheitsdialogComponent extends FocusManagedDialogComponent {

  @Input() 
  public gutachten: GutachtenListDisplayModel;

  public gutachtenForm: GutachtenListDisplayModelFormGroup;

  public get isBegruendungBefangenheitVisible(): boolean {
    return this.gutachtenForm.Befangenheit.value;
  }

  public get isSaveDisabled(): boolean {
    return this.gutachtenForm.invalid || (this.isBegruendungBefangenheitVisible && (this.gutachtenForm.BegruendungBefangenheit.value == null || this.gutachtenForm.BegruendungBefangenheit.value.length == 0));
  }

  constructor(dialog: DialogRef, protected focusService: FocusService){
    super(focusService,dialog)
  }

  ngOnInit(): void {
    this.gutachtenForm = GutachtenListDisplayModelFormGroup.Instance;
    this.gutachtenForm.patchValue(this.gutachten);
    this.gutachtenForm.AnfrageNummer.disable();
    this.gutachtenForm.AnfrageTitel.disable();
    this.gutachtenForm.AntragstellerName.disable();
    this.gutachtenForm.AnfrageBeschreibung.disable();
    this.gutachtenForm.Befangenheit.addValidators(Validators.required);
  }

  public onCancelClick(): void {
    let result = new BefangenheitsDialogResult();
    result.action = ConfirmationDialogAction.Cancel;
    this.dialog.close(result);
  }

  public onConfirmClick(): void {
    let result = new BefangenheitsDialogResult();
    result.action = ConfirmationDialogAction.Confirm;
    result.model = new GutachtenBefangenheitDisplayModel();
    result.model.id = this.gutachten.gutachtenId;
    result.model.befangenheit = this.gutachtenForm.Befangenheit.value;
    if (result.model.befangenheit == true)
      result.model.begruendungBefangenheit = this.gutachtenForm.BegruendungBefangenheit.value;
    this.dialog.close(result);
  }
}

export class BefangenheitsDialogResult extends ConfirmationDialogResult {
  public model: GutachtenBefangenheitDisplayModel;
}
